<template>
  <div v-for="toast in toasts" :key="toast.id" class="relative w-full">
    <SdfAlertToast
      :status="toast.status"
      :message="toast.message"
      :closeable="toast.closeable"
      :auto-close="toast.autoClose"
      :auto-close-after="toast.autoCloseAfter"
      :hide-icon="toast.hideIcon"
      :use-animation="toast.useAnimation"
      :action-label="toast.actionLabel"
      :action-href="toast.actionHref"
      :button-title="toast.buttonTitle"
      :icon-title="toast.iconTitle"
      :close-icon-title="toast.closeIconTitle"
      @sdf-dismiss="handleDismiss(toast)"
      @sdf-after-close="handleAfterClose(toast)"
      @sdf-action="handleAction(toast)"
    />
  </div>
</template>

<script setup lang="ts">
import { removeToast, toasts } from '@pequity/shared/composables/useSdfToast';
import SdfAlertToast from '@pequity/shared/ui/sdf-alert-toast/sdf-alert-toast.vue';

defineOptions({
  name: 'SdfToastContainer',
});

const handleDismiss = (toast: (typeof toasts.value)[0]) => {
  if (toast.onDismiss) {
    toast.onDismiss();
  }
  removeToast(toast.id);
};

const handleAfterClose = (toast: (typeof toasts.value)[0]) => {
  if (toast.onAfterClose) {
    toast.onAfterClose();
  }
  removeToast(toast.id);
};

const handleAction = (toast: (typeof toasts.value)[0]) => {
  if (toast.onAction) {
    toast.onAction();
  }
  removeToast(toast.id);
};
</script>
